<template>
  <div class="container mt-5">
    <h1>MANUTENÇÃO - SAÍDA</h1>
    <router-link
      :to="`/checklist/Layout/form/fill/${$store.getters.formVehicleRevisionExitId}`"
    >
      <b-button style="margin-bottom: 15px" size="sm">
        {{ $t("geral.create") }}
      </b-button>
    </router-link>
    <b-button
      size="sm"
      style="margin-bottom: 15px; margin-left: 10px"
      @click="clearFilters"
    >
      Limpar Filtros
    </b-button>
    <router-link :to="`/checklist/revision/exitConfiguration`">
      <b-button size="sm" style="margin-bottom: 15px; margin-left: 10px" userRms
        >Configurador</b-button
      ></router-link
    >

    <b-table
      :items="maintenanceExits"
      :fields="fields"
      responsive
      class="mt-4"
      :filter="tableFilters"
      :filter-debounce="500"
      :filter-function="filterFunction"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key" class="vertical-align">
            <div v-if="field.key !== 'actions'">
              <template v-if="field.key === 'revisionType'">
                <b-form-select
                  v-model="tableFilters.revisionType"
                  :options="revisionTypeOptionsWithPlaceholder"
                ></b-form-select>
              </template>
              <template v-else-if="field.key === 'exitDate'">
                <b-form-input
                  v-model="tableFilters.exitDate"
                  placeholder="Buscar Data da Saída"
                  type="date"
                ></b-form-input>
              </template>
              <template v-else>
                <b-form-input
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar ' + field.label"
                ></b-form-input>
              </template>
            </div>
          </b-th>
        </b-tr>
      </template>

      <template #cell(exitDate)="data">
        {{ formatDateForDisplay(data.item.exitDate) }}
      </template>
      <template #cell(value)="data">
        {{ formatCurrency(data.item.value) }}
      </template>
      <template v-slot:cell(originChecklistId)="data">
        <router-link 
          :to="'/checklist/form/filled/details/' + data.item.originChecklistId"
        >
          <p>
            <u>
              {{ data.value }}
            </u>
          </p>
        </router-link>
      </template>
      <template v-slot:cell(revisionType)="data">
        {{ getRevisionTypeLabel(data.item.revisionType) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import RevisionExitCreate from "../../../../components_rms/vehicle/Revision/RevisionExitCreate.vue";

export default {
  components: {
    RevisionExitCreate,
  },
  data() {
    return {
      openModal: false,
      maintenanceExits: [],
      isEditMode: false,
      currentExit: {
        id: 0,
        vehicleId: 0,
        companyId: 0,
        plate: "",
        exitDate: "",
        value: 0,
        vehicleRevisionEntryId: null,
      },
      tableFilters: {
        originChecklistId: "",
        description: "",
        plate: "",
        revisionType: "",
        exitDate: "",
        value: "",
      },
      revisionTypeOptions: [
        { value: "0", text: "Preventiva" },
        { value: "1", text: "Corretiva" },
        { value: "2", text: "Sinistro" },
      ],
      revisionTypeOptionsWithPlaceholder: [
        { value: "", text: "Buscar Tipo de Manutenção" },
        { value: "0", text: "Preventiva" },
        { value: "1", text: "Corretiva" },
        { value: "2", text: "Sinistro" },
      ],
      fields: [
        { key: "originChecklistId", label: "Id" },
        { key: "description", label: "Descrição" },
        { key: "plate", label: "Placa" },
        { key: "revisionType", label: "Tipo de Manutenção" },
        { key: "exitDate", label: "Data da Saída" },
        { key: "value", label: "Valor" },
      ],
      currentPage: 1,
      perPage: 10,
      userRms: false,
    };
  },
  mounted() {
    this.fetchExits();
    this.isRmsUser();
  },
  methods: {
    
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then((response) => {
        this.userRms = response.data;
      });
    },
    formatDateForDisplay(date) {
      const d = new Date(date);
      if (isNaN(d)) return "";
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    clearFilters() {
      this.tableFilters = {
        originChecklistId: "",
        description: "",
        plate: "",
        revisionType: "",
        exitDate: "",
        value: "",
      };
    },
    openCreateModal() {
      this.isEditMode = false;
      this.currentExit = {
        id: 0,
        vehicleId: 0,
        companyId: 0,
        plate: "",
        exitDate: "",
        value: 0,
        vehicleRevisionEntryId: null,
      };
      this.openModal = true;
    },
    openEditModal(exit) {
      this.isEditMode = true;
      this.currentExit = { ...exit };
      if (this.currentExit.exitDate) {
        this.currentExit.exitDate = this.formatDateForInput(
          this.currentExit.exitDate
        );
      }
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },
    async fetchExits() {
      try {
        const response = await this.$apiVehicle.get("/GetAllRevisionsExit/");
        this.maintenanceExits = response.data;
        console.log("Saídas de manutenção:", this.maintenanceExits);
      } catch (error) {
        console.error("Erro ao buscar saídas de manutenção:", error);
      }
    },
    handleSuccess() {
      this.openModal = false;
      this.fetchExits();
    },
    onModalHide() {
      this.isEditMode = false;
      this.currentExit = {
        id: 0,
        vehicleId: 0,
        companyId: 0,
        plate: "",
        exitDate: "",
        value: 0,
        vehicleRevisionEntryId: null,
      };
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatDateForInput(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    focusFirstInput() {
      this.$nextTick(() => {
        const firstInput = this.$el.querySelector("input");
        if (firstInput) firstInput.focus();
      });
    },
    getRevisionTypeLabel(revisionType) {
      switch (revisionType.toString()) {
        case "0":
          return "Preventiva";
        case "1":
          return "Corretiva";
        case "2":
          return "Sinistro";
        default:
          return "Desconhecido";
      }
    },
    filterFunction(item, filter) {
      if (
        filter.originChecklistId &&
        !item.originChecklistId.toString().includes(filter.originChecklistId)
      ) {
        return false;
      }
      if (
        filter.description &&
        !item.description
          .toLowerCase()
          .includes(filter.description.toLowerCase())
      ) {
        return false;
      }
      if (
        filter.plate &&
        !item.plate.toLowerCase().includes(filter.plate.toLowerCase())
      ) {
        return false;
      }
      if (
        filter.revisionType &&
        item.revisionType.toString() !== filter.revisionType
      ) {
        return false;
      }
      if (
        filter.exitDate &&
        this.formatDateForInput(item.exitDate) !== filter.exitDate
      ) {
        return false;
      }
      if (filter.value) {
        const valueString = item.value.toString();
        if (!valueString.includes(filter.value)) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
.table th,
.table td {
  text-align: center;
}
.form-group {
  margin-bottom: 15px;
}
.vertical-align {
  vertical-align: middle !important;
}
</style>
